import { IconProp } from '@fortawesome/fontawesome-svg-core';
import * as styles from './NavigationButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NavigationButton = (props: {
  onClick: () => void;
  icon: IconProp;
  disabled: boolean;
  'aria-label': string;
}) => {
  return (
    <div
      role="button"
      aria-label={props['aria-label']}
      aria-disabled={props.disabled}
      className={[
        styles.navigation,
        props.disabled ? styles.disabled : '',
      ].join(' ')}
      onClick={props.onClick}
    >
      {!props.disabled && (
        <FontAwesomeIcon icon={props.icon} className={styles.icon} />
      )}
    </div>
  );
};
